<template>
  <a-card :bordered="false">
    <div>
      <a-row :gutter="24">
        <a-col :span="5">
          <div style="height: 750px; border: 1px solid rgb(240, 242, 245); overflow: auto">
            <a-directory-tree
              :show-line="false"
              :tree-data="treeData"
              @select="onSelect"
              v-if="aa"
              :defaultExpandAll="true"
            />
          </div>
        </a-col>
        <a-col :span="19">
          <a-card
            v-if="this.queryParam.departId"
            :title="userTitle"
            style="width: 100%; margin-bottom: 20px"
            size="small"
          >
            <a-row :gutter="gutter">
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">部门经理：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.bmjl.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('BMJL')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.bmjl" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('BMJL', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('BMJL', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('BMJL')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">事业部经理：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.sybjl.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('SYBJL')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.sybjl" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('SYBJL', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('SYBJL', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('SYBJL')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">组长：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.zz.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('ZZ')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.zz" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('ZZ', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('ZZ', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('ZZ')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="gutter" style="margin-top: 10px">
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">分管领导：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.fgld.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('FGLD')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.fgld" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('FGLD', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('FGLD', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('FGLD')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">分管财务：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.fgcw.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('FGCW')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.fgcw" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('FGCW', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('FGCW', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('FGCW')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row>
                  <a-col :span="6">
                    <span style="float: right; padding-top: 5px">质控员：</span>
                  </a-col>
                  <a-col :span="18">
                    <a-row v-if="userInfo.zky.length == 0" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('ZKY')"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row v-for="(item, index) in userInfo.zky" :key="index" style="margin-top: 5px">
                      <a-col :span="txtWidth">
                        <a-input :value="showUserInfo(item)" :disabled="true" />
                      </a-col>
                      <a-col :span="btnWidth">
                        <a-tooltip placement="top" title="删除">
                          <a-button
                            @click="removeUser('ZKY', item)"
                            type="dashed"
                            shape="circle"
                            icon="delete"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="替换">
                          <a-button
                            @click="goSetting('ZKY', item)"
                            type="dashed"
                            shape="circle"
                            icon="edit"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                        <a-tooltip placement="top" title="添加">
                          <a-button
                            @click="goAdd('ZKY')"
                            v-if="index === 0"
                            type="dashed"
                            shape="circle"
                            icon="plus"
                            style="margin-left: 5px"
                          />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-card>

          <!-- 查询区域 111-->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="12">
                  <a-form-item label="分管角色">
                    <a-select
                      placeholder="请选择分管角色"
                      :default-active-first-option="false"
                      :show-arrow="true"
                      :filter-option="false"
                      :not-found-content="null"
                      v-model="queryParam.type"
                      @change="searchQuery"
                    >
                      <a-select-option value="">请选择</a-select-option>
                      <a-select-option v-for="d in typeDS" :key="d.code">{{ d.value }} </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="真实名字">
                    <a-input placeholder="请输入真实名字" v-model="queryParam.realname"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                    <a-button type="primary" @click="searchReset2" icon="reload" style="margin-left: 8px"
                      >重置</a-button
                    >
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- table区域-begin -->
          <div style="margin-top: 5px">
            <a-table
              ref="table"
              bordered
              size="middle"
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              @change="handleTableChange"
              :scroll="{ x: true }"
            >
            </a-table>
          </div>
          <!-- table区域-end -->

          <DepartManagerHisModal ref="hisModal" @ok="refresh" />
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage.js'
import { queryDepartTreeList } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DepartManagerHisModal from './modules/DepartManagerHisModal'

export default {
  name: 'DepartManagerHisList',
  mixins: [JeecgListMixin],
  components: {
    DepartManagerHisModal
  },
  data() {
    return {
      description: '部门审核人员管理页面',
      treeData: [],
      gutter: { xs: 8, sm: 16, md: 24, lg: 32 },
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      aa: false,
      queryParam: {
        departId: ''
      },
      txtWidth: 14,
      btnWidth: 10,
      curDepart: undefined,
      typeDS: [],
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 50,
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '部门名称',
          align: 'center',
          dataIndex: 'departName',
          width: 200,
          ellipsis: true
        },
        // {
        //     title: '部门编码',
        //     align: "center",
        //     dataIndex: 'orgCode',
        //     width: 80
        // },
        {
          title: '分管职位',
          align: 'center',
          dataIndex: 'typeDesc',
          width: 150,
          ellipsis: true
        },
        {
          title: '分管人员',
          align: 'center',
          dataIndex: 'realname',
          width: 100,
          ellipsis: true
        },
        {
          title: '开始时间',
          align: 'center',
          dataIndex: 'beginTime',
          width: 120,
          ellipsis: true
        },
        {
          title: '结束时间',
          align: 'center',
          dataIndex: 'endTime',
          width: 120,
          ellipsis: true
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createBy',
          width: 100,
          ellipsis: true
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 120,
          ellipsis: true
        },
        {
          title: '修改人',
          align: 'center',
          dataIndex: 'updateBy',
          width: 100,
          ellipsis: true
        },
        {
          title: '修改时间',
          align: 'center',
          dataIndex: 'updateTime',
          width: 120,
          ellipsis: true
        }
      ],
      url: {
        list: '/api/sysdepartmanagerhis/list'
      },
      userInfo: {
        bmjl: {
          userId: '',
          username: '',
          realname: ''
        },
        sybjl: {
          userId: '',
          username: '',
          realname: ''
        },
        fgld: {
          userId: '',
          username: '',
          realname: ''
        },
        fgcw: {
          userId: '',
          username: '',
          realname: ''
        },
        zky: {
          userId: '',
          username: '',
          realname: ''
        },
        zz: {
          userId: '',
          username: '',
          realname: ''
        }
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    userTitle() {
      if (!this.curDepart) {
        return '当前分管角色'
      }
      return '当前分管角色——' + this.curDepart.departName + '（' + this.curDepart.orgCode + '）'
    }
  },
  methods: {
    refresh() {
      this.getCurDepartUserInfo()
      this.searchQuery()
    },
    showUserInfo(user) {
      return user.userId ? user.username + '（' + user.realname + '）' : ''
    },
    getCurDepartUserInfo() {
      if (!this.curDepart) {
        this.userInfo = {
          bmjl: {
            userId: '',
            username: '',
            realname: ''
          },
          sybjl: {
            userId: '',
            username: '',
            realname: ''
          },
          fgld: {
            userId: '',
            username: '',
            realname: ''
          },
          fgcw: {
            userId: '',
            username: '',
            realname: ''
          },
          zky: {
            userId: '',
            username: '',
            realname: ''
          },
          zz: {
            userId: '',
            username: '',
            realname: ''
          }
        }
      } else {
        getAction('api/sysdepartmanagerhis/getCurDepartUserInfo', {
          departId: this.curDepart.id
        }).then((res) => {
          if (res.success) {
            this.userInfo = res.result
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    goAdd(type) {
      this.$refs.hisModal.show(this.curDepart, type)
    },
    goSetting(type, user) {
      this.$refs.hisModal.show(this.curDepart, type, user)
    },
    removeUser(type, user) {
      let postName = ''
      if (type == 'BMJL') {
        postName = '部门经理'
      } else if (type == 'SYBJL') {
        postName = '事业部经理'
      } else if (type == 'FGLD') {
        postName = '分管领导'
      } else if (type == 'FGCW') {
        postName = '分管财务'
      } else if (type == 'ZKY') {
        postName = '质控员'
      } else if (type == 'ZZ') {
        postName = '组长'
      }
      let content =
        '【' +
        user.realname +
        '】不再担任' +
        '【' +
        this.curDepart.departName +
        '】【' +
        postName +
        '】， 确认执行该操作？'
      var that = this
      let departId = this.curDepart.id
      this.$confirm({
        title: '提示',
        content: content,
        onOk: function () {
          postAction('api/sysdepartmanagerhis/removeUser', {
            departId: departId,
            type: type,
            userId: user.userId
          }).then((res) => {
            if (res.success) {
              that.$message.success('删除成功')
              that.refresh()
            } else {
              that.$message.error(res.message)
            }
          })
        }
      })
    },
    searchReset2() {
      this.queryParam.type = ''
      this.queryParam.realname = ''
      this.searchQuery()
    },
    init() {
      this.aa = false //强制树重新渲染
      queryDepartTreeList().then((res) => {
        if (res.success) {
          this.$nextTick(() => {
            this.aa = true
            this.treeData = res.result
          })
        } else {
          this.$message.error(res.message)
        }
      })
      getAction('api/common/select/byType/SysDepartManagerHisEnum').then((res) => {
        if (res.success) {
          this.$nextTick(() => {
            this.typeDS = res.result
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onSelect(selectedKeys, e) {
      let cur = e.selectedNodes[0].dataRef

      console.log('selected', cur)
      if (!cur.parentId) {
        //根节点
        this.curDepart = undefined
        this.queryParam.departId = ''
        this.refresh()
      } else {
        this.curDepart = cur
        this.queryParam.departId = cur.key
        this.refresh()
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
